import React from "react";
import { Box } from "@chakra-ui/react";
import MidnightSky from "./Components/MidnightSky";
import ScrollProgress from "./Components/ScrollProgress";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import About from "./Components/About";
import Education from "./Components/Education";
import WorkExperiance from "./Components/WorkExperiance";
import Skills from "./Components/Skills";
import Project from "./Components/Project";
import Github from "./Components/Github";
import Recommendations from "./Components/Recommendations";
import Contact from "./Components/Contact";

function App() {
  return (
    <Box position="relative" fontFamily="sans-serif" width="100%" color="#ececed" overflowX="hidden">
      {/* deep midnight base — the night behind the stars */}
      <Box
        position="fixed"
        inset="0"
        zIndex="0"
        pointerEvents="none"
        bgGradient="linear(to-b, #0b1226 0%, #080d1b 45%, #05070f 100%)"
      />

      {/* the midnight sky: moon, twinkling stars, clouds, shooting stars */}
      <MidnightSky />

      {/* soft vignette for cinematic depth at the edges */}
      <Box
        position="fixed"
        inset="0"
        zIndex="1"
        pointerEvents="none"
        bgGradient="radial(ellipse at 50% 40%, transparent 55%, rgba(4,6,12,0.6) 100%)"
      />

      {/* reading progress bar */}
      <ScrollProgress />

      {/* the story, told in chapters (sits above the sky) */}
      <Box position="relative" zIndex="2">
        <Navbar />
        <Home />
        <About />
        <Education />
        <WorkExperiance />
        <Skills />
        <Project />
        <Github />
        <Recommendations />
        <Contact />
      </Box>
    </Box>
  );
}

export default App;
